import React from 'react'
import SketchField from './SketchField'

const SketchCanvas = ({ lineWidth, color, image, canvasRef, loading, imageDimensions }) => {
  return (
    <div className="flex justify-center items-center">
      <SketchField
        ref={canvasRef}
        height={imageDimensions.height}
        width={imageDimensions.width}
        lineColor={color}
        lineWidth={lineWidth}
        backgroundColor={loading ? 'black' : 'transparent'}
        style={
          !loading
            ? {
                backgroundImage: `url(${image})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }
            : {}
        }
      />
    </div>
  )
}

export default SketchCanvas
